import { render, staticRenderFns } from "./bargeForm.vue?vue&type=template&id=711a8dd1&scoped=true&"
import script from "./bargeForm.vue?vue&type=script&lang=js&"
export * from "./bargeForm.vue?vue&type=script&lang=js&"
import style0 from "./bargeForm.vue?vue&type=style&index=0&id=711a8dd1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711a8dd1",
  null
  
)

export default component.exports